import { render } from "./AudienceCenter.vue?vue&type=template&id=03e28fb4&scoped=true"
import script from "./AudienceCenter.vue?vue&type=script&lang=js"
export * from "./AudienceCenter.vue?vue&type=script&lang=js"

import "./AudienceCenter.vue?vue&type=style&index=0&id=03e28fb4&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e28fb4"]])

export default __exports__